import React, { lazy } from 'react';
import { Routes as ReactRouterDomRoutes, Route } from 'react-router-dom';
import DetailView from './vehicle-view/components/DetailView';

const Accessories = lazy(() => import('./accessories'));
const Accessory = lazy(() => import('./accessory'));
const Dashboard = lazy(() => import('./dashboard'));
const Administrators = lazy(() => import('./administrators'));
const Administrator = lazy(() => import('./administrators/Administrator'));
const BankId = lazy(() => import('./bankid'));
const BranchList = lazy(() => import('./branches/components/branch-list-v2'));
const Branch = lazy(() => import('./branches/branch'));
const Permissions = lazy(() => import('./permissions/permissions'));
const MarketSettings = lazy(() => import('./market-settings'));
const Synonym = lazy(() => import('./synonym'));
const Users = lazy(() => import('./users'));
const WXR = lazy(() => import('./wxr'));
const SystemClientList = lazy(() => import('./system-clients'));
const BlocketView = lazy(() => import('./blocket-view'));
const BlocketOutboxStats = lazy(() => import('./blocket-outbox-stats'));
const VehicleView = lazy(() => import('./vehicle-view'));
const VirtualVehicleList = lazy(() => import('./virtual-vehicle'));
const VirtualVehicleAddEditPage = lazy(() => import('./virtual-vehicle/components/AddEditPage'));
const AssignmentOptionsOverview = lazy(() => import('./assignment-options'));
const Websites = lazy(() => import('./websites'));
const Profile = lazy(() => import('./profile'));
const SeoItem = lazy(() => import('./seo/seo-item'));
const Seo = lazy(() => import('./seo'));
const MassDeletinonProtectionSingle = lazy(
  () => import('./mass-deletion-protection/MassDeletionProtectionSingle'),
);
const MassDeletinonProtection = lazy(() => import('./mass-deletion-protection'));
const AlertBanners = lazy(() => import('./alert-banners'));
const Unarchive = lazy(() => import('./unarchive'));
const FinancingProvider = lazy(() => import('./financing-provider'));
const FinancingProviders = lazy(() => import('./financing-providers'));

const Routes = () => (
  <ReactRouterDomRoutes>
    <Route path="/" element={<Dashboard />} />
    <Route path="/financing-providers/:id" element={<FinancingProvider />} />
    <Route path="/financing-providers" element={<FinancingProviders />} />
    <Route path="/settings" element={<MarketSettings />} />
    <Route path="/accessories/:id" element={<Accessory />} />
    <Route path="/accessories" element={<Accessories />} />
    <Route path="/websites" element={<Websites />} />
    <Route path="/synonyms/:page" element={<Synonym />} />
    <Route path="/synonyms" element={<Synonym />} />
    <Route path="/administrators/:id" element={<Administrator />} />
    <Route path="/administrators" element={<Administrators />} />
    <Route path="/branches/:id/:view?" element={<Branch />} />
    <Route path="/branches" element={<BranchList />} />
    <Route path="/permissions" element={<Permissions />} />
    <Route path="/users" element={<Users />} />
    <Route path="/wxr-boost" element={<WXR />} />
    <Route path="/system-clients" element={<SystemClientList />} />
    <Route path="/unarchive" element={<Unarchive />} />
    <Route path="/blocket-view" element={<BlocketView />} />
    <Route path="/blocket-outbox-stats" element={<BlocketOutboxStats />} />
    <Route path="/vehicle-view" element={<VehicleView />} />
    <Route
      path="/vehicle-view/import-config/:vehicle"
      element={<DetailView type="importConfig" />}
    />
    <Route
      path="/vehicle-view/record-detail/:vehicle"
      element={<DetailView type="recordDetailDoc" />}
    />
    <Route
      path="/vehicle-view/search-service/:vehicle"
      element={<DetailView type="searchServiceDoc" />}
    />
    <Route
      path="/vehicle-view/vehicle-item/:vehicle"
      element={<DetailView type="vehicleItemDoc" />}
    />
    <Route path="/virtual-vehicle" element={<VirtualVehicleList />} />
    <Route path="/virtual-vehicle/new" element={<VirtualVehicleAddEditPage />} />
    <Route path="/virtual-vehicle/:templateId" element={<VirtualVehicleAddEditPage />} />
    <Route path="/bankid" element={<BankId />} />
    <Route path="/assignment-options" element={<AssignmentOptionsOverview />} />
    <Route path="/profile" element={<Profile />} />
    <Route path="/seo/:id" element={<SeoItem />} />
    <Route path="/seo" element={<Seo />} />
    <Route path="/mass-deletion-protection/:id" element={<MassDeletinonProtectionSingle />} />
    <Route path="/mass-deletion-protection" element={<MassDeletinonProtection />} />
    <Route path="/alert-banners" element={<AlertBanners />} />
    <Route path="/oidc/signin" element={<p>Sign in...</p>} />
  </ReactRouterDomRoutes>
);

export default Routes;
